import React from "react";

const SvgEqual = props => (
  <svg viewBox="0 0 36 36" {...props}>
    <path d="M0 11h36v4H0zM0 21h36v4H0z" />
  </svg>
);

export default SvgEqual;
